import { useMemo } from 'react'

import {
  CreatorProxySettingsRestEndpointService,
  type ProxySettingsBody,
} from '@api'
import { useMutation, useQuery } from 'react-query'
import { handleError } from '@/utils/error'
import type { Creator } from '@/modules/creators/types.ts'

export const useCreatorProxySettings = (
  showProxyConfigurationDialog: boolean,
  creator: Creator,
) => {
  const query = useQuery(
    ['proxySettings', showProxyConfigurationDialog, creator.id],
    async () => {
      if (!showProxyConfigurationDialog) {
        return
      }

      return CreatorProxySettingsRestEndpointService.getProxySettings({
        creatorId: creator.id,
      })
    },
    {
      enabled: !!creator.id,
      onError: (error) => handleError(error, 'Failed to get proxy settings'),
    },
  )

  const updateMutation = useMutation(async (update: ProxySettingsBody) => {
    return CreatorProxySettingsRestEndpointService.setProxySettings({
      creatorId: creator.id,
      requestBody: update,
    })
  })

  return useMemo(
    () => ({
      query,
      updateMutation,
    }),
    [query, updateMutation],
  )
}
